import { Typography } from '@mui/material';
import { UseTableCellProps } from 'react-table';
import { formatDate } from 'shared/utility';

export function DateColumn<T extends object>({ value }: UseTableCellProps<T>) {
    return <Typography variant='body2'>{value ? formatDate(new Date(value)) : value}</Typography>;
}
